import useRequest from '@src/utils/hooks/use-request';
import {  useEffect } from 'preact/hooks';
import {createRef} from "preact";
import rsa from '@xfe/rsa-zt';
import { observable } from 'mobx';
import JsonService from '@src/services/json';
import { autobind } from 'core-decorators';
import _ from 'lodash';
// import captchaDecoUtil from '@src/utils/captcha-deco-util';
import intl from 'react-intl-universal';
import ThirdPartyLoginStore from '@src/business-components/sign-in/third-party-login';
import accountStore from '@src/models/account';
import { ZT_PUBLIC_KEY } from '@src/constants';
import lockAsync from '@src/utils/lock-async';
import useMount from '@src/utils/hooks/use-mount';
import { async } from '@src/utils/func-deco-util';
import { $$tracker } from '@src/tracker';
import desensitizationEmail from '@src/utils/desensitizationEmail';
import CaptchaHandler from '@xfe/captcha-handler';
import jsonp from '@src/utils/jsonp-util';
import { CAPTCHA_ZT_PIC_URL, CAPTCHA_ZT_PRE_AUTH } from '@src/constants/urls';
import { GEETEST_LANGUAGE } from '@src/utils/locale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import message from '@src/utils/message';

const formLock = function() {
  return async({
    before() {
      this.formLock = true;
    },
    after(result) {
      if (result && result.then) {
        result
          .finally(() => {
            this.formLock = false;
          })
          .catch(f => f);
      } else {
        this.formLock = false;
      }
    }
  });
};

export default class SignInStore {
  captchaHandler;

  /**
   * config载入状态
   * @type {boolean}
   */
  @observable loadingStatus = false;
  /***
   * publicKey
   * @type {string}
   */
  @observable publicKey = '';

  /**
   * 用户提交状态
   * @type {boolean}
   */
  @observable submitBtnDisable = true;

  /**
   * 第三方登录方式
   * @type {ThirdPartyLoginStore[]}
   */
  @observable loginType = [];

  /**
   * 是否显示激活页面
   * @type {boolean}
   */
  @observable needActiveStatus = false;

  @observable activeOpenId = '';

  @observable
  link = {
    userAgreement: '',
    privacyAgreement: ''
  };

  $service = JsonService.getZTDefaultInstance({});

  formRef = createRef();

  /**
   * 登录表单值
   * @type {{}}
   */
  @observable formValue = {};

  @observable needCaptchaStatus = {};

  @autobind
  changeProtocolStatus(value) {
    this.protocolStatus = value;
  }

  checkCodeValue(value) {
    let check = true;
    Object.keys(value).forEach(key => {
      if (!_.trim(value[key])) {
        check = false;
      }
    });
    if (check) {
      this.submitBtnDisable = false;
    } else {
      this.submitBtnDisable = true;
    }
  }

  /**
   * 需要验证码
   * @param [params]
   * @return {Promise<string>}
   */
  // @captchaDecoUtil('zt')
  async needCaptcha() {
    const { state, data } = await this.captchaHandler.verify({ cache: false });
    if (state === 1) {
      return JSON.stringify(data);
    }
    throw new Error('captcha fail');
    //return JSON.stringify();
  }

  // @captchaDecoUtil('zt')
  async needCaptcha2() {
    const { state, data } = await this.captchaHandler.verify({ cache: false });
    if (state === 1) {
      return data;
    }
    throw new Error('captcha fail');
    // return params;
  }

  @autobind
  backToSignIn() {
    this.needActiveStatus = false;
  }

  debounceMark = false;

  @observable formLock = false;

  @autobind
  @lockAsync()
  @formLock()
  async loginHandle() {
    if (this.debounceMark) {
      return;
    }
    this.debounceMark = true;
    setTimeout(() => {
      this.debounceMark = false;
    }, 200);
    if (!this.protocolStatus) {
      message.error(intl.get('PAGE.SIGN_IN.PROTOCOL.REQUIRED.TEXT'));
      return;
    }
    const asyncFormValid = new Promise((resolve, reject) => {
      this.formRef.current.props.form.validateFieldsAndScroll((error, value) => {
        if (!error) {
          resolve(value);
        } else {
          reject(new Error(JSON.stringify(error)));
        }
      });
    });

    try {
      this.formValue = await asyncFormValid;
      await this.login();
      $$tracker.loginAccountSuccess(desensitizationEmail(this.formValue.email), 'seasun通行证', accountStore.openId);
    } catch (e) {
      if (!e) {
        return;
      }
      if (e.serviceResponse) {
        if (e.serviceResponse.code === 3011) {
          this.needCaptchaStatus[this.formValue.email] = true;
        }
      }
      let code = e.code;
      if (e.serviceResponse) {
        code = e.serviceResponse.code;
      }
      if (e.message) {
        console.log(e);
        $$tracker.loginAccountFail(desensitizationEmail(this.formRef.current.props.form.getFieldValue('email')), e.message, code);
        if (typeof e.code === 'number') {
          message.error(e.message);
        }
      }
    }
  }

  @autobind
  @lockAsync()
  async activeHandle() {
    try {
      await this.$service.stopCancelPassport({
        open_id: this.activeOpenId
      });
      await this.login();
      $$tracker.loginAccountSuccess(desensitizationEmail(this.formValue.email), 'seasun通行证', accountStore.openId);
    } catch (e) {
      if (!e) {
        return;
      }
      if (e.serviceResponse) {
        if (e.serviceResponse.code === 3011) {
          this.needCaptchaStatus[this.formValue.email] = true;
        }
      }
      let code = e.code;
      if (e.serviceResponse) {
        code = e.serviceResponse.code;
      }
      if (e.message) {
        $$tracker.loginAccountFail(desensitizationEmail(this.formValue.email), e.message, code);
        if (typeof e.code === 'number') {
          message.error(e.message);
        }
      }
    }
  }

  @autobind
  async login() {
    let extParams = {};
    $$tracker.loginAccountStart(desensitizationEmail(this.formValue.email), 'seasun通行证');
    const accountStateData = await this.$service.getAccountState({ uid: this.formValue.email, bind_type: 1 });
    // captchar.preauth
    console.log("!!!", accountStateData);
    if (accountStateData.state === -2) {
      rsa.updatePublicKey(ZT_PUBLIC_KEY);
      let params = {};
      if (this.needCaptchaStatus[this.formValue.email]) {
        // captchar.
        const data = await this.needCaptcha2();
        params = {
          geetest_validator: 'overseas_offical',
          ...data
        };
      }
      this.$service
        .loginForActive({
          email: this.formValue.email,
          password: rsa.encrypt(this.formValue.password),
          encrypt_method: 'rsa',
          // ...extParams,
          ...params
        })
        .then(
          data => {
            const { open_id } = data;
            this.needActiveStatus = true;
            this.activeOpenId = open_id;
            this.needCaptchaStatus[this.formValue.email] = false;
          },
          error => {
            if (error.serviceResponse) {
              if (error.serviceResponse.data.is_need_captcha) {
                this.needCaptchaStatus[this.formValue.email] = true;
              }
              if (error.serviceResponse.code === -10604) {
                this.login().finally();
                return;
              }
              message.error(error.message);
            }
          }
        )
        .finally(() => {
          rsa.updatePublicKey(this.publicKey);
        });

      return;
    }
    if (this.needCaptchaStatus[this.formValue.email]) {
      extParams = {
        ext: await this.needCaptcha()
      };
    }
    const data = await this.$service.login({
      thirdPartyType: 'mail',
      email: this.formValue.email,
      password: rsa.encrypt(this.formValue.password),
      ...extParams
    });
    await this.$service.setLoginInfo({ token: data.token });
    this.needCaptchaStatus = {};
    accountStore.loginType = 'login';
    accountStore.updateStatus(data);
    message.success(intl.get('PAGE.SIGN_IN.SUCCESS.TEXT'));
  }

  use() {
    const getConfigRequest = useRequest(() => this.$service.getConfig({}));
    useMount(() => {
      const params = {
        geeTestSettings: {
          /**
           * 请求 pre auth 请求实现
           * @param url
           * @param params
           * @return {*}
           */
          requestPreAuthImpl(url, params = {}) {
            /**
             * 要求请求后返回 {message, data} 的数据结构
             */
            return jsonp(CAPTCHA_ZT_PRE_AUTH, { geetest_validator: 'overseas_offical', uri: 'seasun/ext/getGeettestStatus', ...params });
          },
          options: { language: GEETEST_LANGUAGE[getLanguageByPath()] }
        },
        pictureSettings: {
          /**
           * 降级 Image 地址,
           * 针对 XOYO 网使用 CAPTCHA_XOYO_PIC_URL
           * 针对专题相关使用 CAPTCHA_ZT_PIC_URL
           */
          captchaPicUrl: CAPTCHA_ZT_PIC_URL
        }
      };
      this.captchaHandler = new CaptchaHandler(params);
    }, []);
    useEffect(
      () => {
        this.loadingStatus = getConfigRequest.loading;
      },
      [getConfigRequest.loading]
    );
    useEffect(
      () => {
        if (getConfigRequest.error) {
          console.log(getConfigRequest.error);
          message.error(getConfigRequest.error.message);
        }
      },
      [getConfigRequest.error]
    );
    useMount(() => {
      const loginFn = async e => {
        if (e.key === 'Enter') {
          await this.loginHandle();
        }
      };
      document.addEventListener('keyup', loginFn);
      return () => {
        document.removeEventListener('keyup', loginFn);
      };
    });
    useEffect(
      () => {
        if (getConfigRequest.data) {
          const { privacyAgreement, userAgreement, platformPrivacyAgreement, platformUserAgreement, accountPublicKey, loginType } = getConfigRequest.data;
          this.loginType = loginType.filter(name => name !== 'mail' && (DEPLOY_ENV !== 'master' ? true : name !== 'guest')).map(
            name =>
              new ThirdPartyLoginStore({
                name,
                preLogin: () => {
                  if (!this.protocolStatus) {
                    message.error(intl.get('PAGE.SIGN_IN.PROTOCOL.REQUIRED.TEXT'));
                    return false;
                  } else {
                    return true;
                  }
                }
              })
          );
          this.link.privacyAgreement = platformPrivacyAgreement;
          this.link.userAgreement = platformUserAgreement;
          rsa.updatePublicKey(accountPublicKey);
          this.publicKey = accountPublicKey;
        }
      },
      [getConfigRequest.data]
    );
  }
}
